import apiFetch from '../apiFetch'

export default function (salesmanId, token) {
  return apiFetch({ endPoint: 'User/Salesman/' + salesmanId + '/Recover', method: 'PUT', body: null, token: token })
}
